module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/src/i18n",
  "moduleName": "H5-soda-fe-b_c_entrega_business_i18n",
  "prefix": "b_c_entrega_business_i18n---",
  "noParse": true,
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-soda-fe-b_c_entrega_business_i18n/src/i18n/all.js"
}